export default {
    getMenu: function (name) {
        // console.log("===============name",name)
        let menu = [
            {
                'label': '账号管理',
                'icon': 'el-icon-s-goods',
                'role': [],
                'router': 'admin_shops',
                'show': true,
                'children': [
                    {
                        'label': '抖店',
                        'role': [],
                        'router': 'admin_doushops',

                        'children': [
                            {
                                'class': '',
                                'label': '斗店账号列表',
                                'role': [],
                                'router': 'admin_doushops',
                            },
                            {
                                'class': '',
                                'label': '店铺中控台',
                                'role': [],
                                'router': 'admin_shop_console',
                            },
                            // {
                            //     'label': '测试',
                            //     'role': [],
                            //     'router': 'admin_test_test',
                            // },
                        ]
                    },
                    {
                        'label': '微小店',
                        'role': [],
                        'router': 'admin_doushops',
                        'children': [
                            {
                                'class': '',
                                'label': '小店账号列表',
                                'role': [],
                                'router': 'admin_weixinshops',
                            },
                            // {
                            //     'label': '测试',
                            //     'role': [],
                            //     'router': 'admin_test_test',
                            // },
                        ]
                    },
                    {
                        'label': '系统账号',
                        'role': [],
                        'router': 'admin_submasters',
                        'children': [
                            {
                                'class': '',
                                'label': '上架充值',
                                'role': [],
                                'router': 'admin_doushop_topup',
                            }, {
                                'class': '',
                                'label': '解析充值',
                                'role': [],
                                'router': 'admin_doushop_topup2',
                            },
                            // {
                            //     'label': '微小店卡密充值',
                            //     'role': [],
                            //     'router': 'admin_doushop_topup3',
                            // },
                            {
                                'class': '',
                                'label': '子账号列表',
                                'role': [],
                                'router': 'admin_submasters',
                            },
                        ]
                    }
                ]
            },
            {
                'label': '智能客服',
                'icon': 'el-icon-chat-dot-round',
                'role': [],
                'router': 'admin_kefu_smart_reply',
                'show': true,
                'children': [
                    {
                        'label': 'AI 接待',
                        'icon': 'el-icon-s-opportunity',
                        'role': [],
                        'router': 'admin_kefu_smart_reply',
                        'children': [
                            {
                                'class': '',
                                'label': '智能回复',
                                'role': [],
                                'router': 'admin_kefu_smart_reply',
                                'new': true,
                            },
                            {
                                'class': '',
                                'label': '回复记录',
                                'role': [],
                                'router': 'admin_kefu_reply_log',
                            },
                            {
                                'class': '',
                                'label': '匹配规则',
                                'role': [],
                                'router': 'admin_kefu_match_rule',
                            },
                            {
                                'class': '',
                                'label': '属性同义词',
                                'role': [],
                                'router': 'admin_kefu_attr_synonym',
                            },
                            {
                                'class': '',
                                'label': '问答库',
                                'role': [],
                                'router': 'admin_kefu_faq_library',
                            },
                        ],
                    },
                ],
            },
            {
                'label': '上货🔥',
                'icon': 'el-icon-s-open',
                'role': [],
                'router': 'admin_commodity_copy',
                'show': true,
                'children': [
                    {
                        'label': '工具',
                        'role': [],
                        'router': 'admin_commodity_copy',
                        'children': [
                            {
                                'class': '',
                                'label': '精细化上架',
                                'role': [],
                                'router': 'admin_commodity_copy',
                            },
                            {
                                'class': '',
                                'label': '铺货上架🔥',
                                'role': [],
                                'router': 'admin_commodity_copy_list',
                            },
                            {
                                'class': '',
                                'label': '铺货操作日志',
                                'role': [],
                                'router': 'admin_commodity_copy_oplog',
                            },
                            {
                                'class': '',
                                'label': 'A店搬B店(跨平台互搬)🔥',
                                'role': [],
                                'router': 'admin_banjia_index',
                            },
                            
                            {
                                'class': '',
                                'label': '搬家设置',
                                'role': [],
                                'router': 'admin_commodity_settings',
                            },
                            {
                                'class': '',
                                'label': '批量修改',
                                'role': [],
                                'router': 'admin_piliangxiugai',
                            },
                            {
                                'class': '',
                                'label': '抖店商品编辑',
                                'new': true,
                                'role': [],
                                'router': 'admin_doudian_shop_edit',
                            },
                            {
                                'class': '',
                                'label': 'AI鉴图(标准版)🔥',
                                'hot': true,
                                'role': [],
                                'router': 'admin_aisee_standard',
                            },
                            {
                                'class': '',
                                'label': 'AI鉴图(高级版)',
                                'role': [],
                                'router': 'admin_aisee',
                            },
                            {
                                'class': '',
                                'label': 'AI鉴图(普通版)',
                                'role': [],
                                'router': 'admin_aisee_basic',
                            },
                            {
                                'class': '',
                                'label': '违规预警',
                                'role': [],
                                'router': 'admin_violation_ticket',
                            },
                            {
                                'class': '',
                                'label': '评价列表',
                                'role': [],
                                'router': 'admin_comment_list',
                            },
                            {
                                'class': '',
                                'label': '低动销无销量清理',
                                'role': [],
                                'router': 'admin_low_sales_zero_sell_clean',
                            }
                            // (process.env.NODE_ENV == "development"?{'label': '解析数据','role': [],'router': 'admin_pddlisten_index'}:undefined)
                            // {
                            //     'label': '解析数据',
                            //     'role': [],
                            //     'router': 'admin_pddlisten_index',
                            // }
                            // name=="deli"||name=="kushang"?(
                            // {
                            //     'label': '草稿箱管理',
                            //     'role': [],
                            //     'router': 'admin_drafts_index',
                            // }):false,
                        ].filter(Boolean),
                    },
                    {
                        'label': '云商品库',
                        'role': [],
                        'router': 'admin_commodity_storehouse',
                        'children': [
                            {
                                'class': '',
                                'label': '上架历史',
                                'role': [],
                                'router': 'admin_commodity_listinghistory',
                            },
                            {
                                'class': '',
                                'label': '云商品库',
                                'role': [],
                                'router': 'admin_commodity_storehouse',
                            },
                            {
                                'class': '',
                                'label': 'A店搬B店记录',
                                'role': [],
                                'router': 'admin_banjia_listinghistory',
                            },
                        ],
                    },
                    {
                        'label': '运营工具',
                        'role': [],
                        'router': 'admin_shangjitibao',
                        'children': [
                            {
                                'class': '',
                                'label': '商机提报🔥',
                                'role': [],
                                'router': 'admin_shangjitibao',
                            },
                            {
                                'class': '',
                                'label': '商机提报增强版',
                                'role': [],
                                'router': 'admin_shangjitibao_enhanced',
                            },
                            {
                                'class': '',
                                'label': '限时限量购',
                                'role': [],
                                'router': 'admin_xianshixianlianggou',
                            },
                            {
                                'class': '',
                                'label': '新人礼金',
                                'role': [],
                                'router': 'admin_xinrenlijin',
                            },
                            {
                                'class': '',
                                'label': '优惠券',
                                'role': [],
                                'router': 'admin_youhuiquan',
                            },
                            {
                                'class': '',
                                'label': '抖店下单二维码',
                                'role': [],
                                'router': 'admin_doudian_order_qrcode',
                            },
                            {
                                'class': '',
                                'label': '商机/限时限量购工作流',
                                'role': [],
                                'router': 'admin_gongzuoliu',
                            },
                            {
                                'class': '',
                                'label': '清理无流量',
                                'role': [],
                                'router': 'admin_qinglizhixiao',
                            },
                            {
                                'class': '',
                                'label': '清理低质商品',
                                'role': [],
                                'router': 'admin_qinglidizhishangpin',
                            },
                            {
                                'class': '',
                                'label': '商品质量诊断清理',
                                'role': [],
                                'router': 'admin_shangpinzhiliangzhenduan',
                            },
                        ],
                    },
                ]
            },
            {
                'label': '巨量千川',
                'icon': 'el-icon-s-marketing',
                'role': [],
                'router': 'admin_qianchuan_quanyu',
                'show': true,
                'children': [
                    {
                        'label': '投放管理',
                        'role': [],
                        'router': 'admin_qianchuan_quanyu',
                        'children': [
                            {
                                'class': '',
                                'label': '乘方计划',
                                'role': [],
                                'router': 'admin_qianchuan_chengfang',
                            },
                            {
                                'class': '',
                                'label': '全域计划',
                                'role': [],
                                'router': 'admin_qianchuan_quanyu',
                            },
                            {
                                'class': '',
                                'label': '千川数据',
                                'role': [],
                                'router': 'admin_qianchuan_data',
                            },
                            {
                                'class': '',
                                'label': '千川监控',
                                'role': [],
                                'router': 'admin_qianchuan_setting',
                            },
                        ],
                    },
                ],
            },
            {
                'label': '视频创作',
                'icon': 'el-icon-video-camera',
                'role': [],
                'router': 'admin_source_video_download',
                'show': true,
                'children': [
                    {
                        'label': '工具',
                        'role': [],
                        'router': 'admin_source_video_download',
                        'children': [
                            {
                                'class': '',
                                'label': '选品中心',
                                'role': [],
                                'router': 'admin_product_selection',
                            },
                            {
                                'class': '',
                                'label': '一刀不剪',
                                'role': [],
                                'router': 'admin_source_video_download',
                            },
                        ],
                    },
                ],
            },
        ]
        // for (let i = 0; i < menu.length; i++) {
        //     let me = menu[i];
        //     if (me.children && me.children.length > 0) {
        //         for (let j = 0; j < me.children.length; j++) {
        //             let m2 = me.children[j];
        //             if (m2.label == "工具" && process?.env?.NODE_ENV == "development") {
        //                 m2.children.push({ 'label': '解析数据', 'role': [], 'router': 'admin_pddlisten_index' });
        //             }
        //         }
        //     }
        // }
        return menu;
    },
}